import React from 'react';
import { motion } from 'framer-motion';
import './Result.css';
const Result = () => {
  return (
    <div className='results-container'>
      <div>
        <motion.button
          style={{
            width: 'fit-content',
            padding: '0.9rem',
            backgroundColor: 'transparent',
            color: 'white',
            textAlign: 'center',
            boxShadow: '0 0 1px white',
            border: 'none',
            borderRadius: '0.7rem',
            cursor: 'pointer',
            fontSize: 'var(--framer-font-size)',
            fontFamily: 'var(--framer-font-family)', // Apply font settings
            fontWeight: 'var(--framer-font-weight)',
            letterSpacing: 'var(--framer-letter-spacing)',
            textAlign: 'center', // Center the button text
          }}
          whileHover={{
            boxShadow:
              '0 0 5px black, 0 0 10px black, 0 0 15px white, 0 0 20px black', // Glow effect with white in between
            transition: { duration: 0.5 }, // Slow-motion effect
          }}
          whileTap={{
            scale: 0.9, // Shrink the button slightly on tap
            transition: { duration: 0.2 }, // Quick tap effect
          }}
        >
          Results
        </motion.button>
      </div>
      <div>
        <h1
          className='framer-text'
          style={{
            textAlign: 'center',
            color: 'white',
            fontWeight: 'var(--framer-font-weight)',
          }}
        >
          <span
            style={{
              display: 'inline-block',
              filter: 'blur(0px)',
              opacity: '1',
              transform: 'none',
              willChange: 'auto',
            }}
          >
            Work speak for <em style={{fontFamily: 'instrument-serif'}}>itself</em>
          </span>
        </h1>
      </div>

      <div
        className='framer-nqkn6i'
        data-framer-component-type='RichTextContainer'
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexShrink: '0',
          justifyContent: 'flex-start',
          outline: 'none',
          flexWrap: 'wrap',
          transform: 'none',
        }}
      >
        <p
          style={{
            color: '#9c9c9c',
            fontSize: '1.2rem',
            lineHeight: '2rem',
            margin: '1rem 0',
            fontWeight: 'var(--framer-font-weight)',
            textAlign: 'center',
            fontFamily: 'var(--framer-font-family)',
            textAlign: 'center',
          }}
        >

            After helping countless entrepreneurs and brands start or grow their<br/>
            social media accounts, we have nailed a winning content strategy...

        </p>
      </div>
    </div>
  );
};

export default Result;
